import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import "../../styles/OwnerAssignedExercises.css";
import OwnerAssignedExerciseItem from "./OwnerAssignedExerciseItem";

const OwnerAssignedExercisesList = ({ exercises }) => {
    const { t } = useTranslation('exercises');
    const [expandedId, setExpandedId] = useState(null);

    if (!Array.isArray(exercises) || exercises.length === 0) {
        return (
            <div className="owner-empty-exercises-state">
                <p className="owner-empty-exercises-text">{t('noAssignedExercises')}</p>
                <img src="/petboard-empty.png" alt="No exercises" className="owner-empty-exercises-image" />
            </div>
        );
    }

    const toggleExpand = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    return (
        <div className="owner-exercise-list">
            {exercises.map((assignedExercise) => (
                <OwnerAssignedExerciseItem
                    key={assignedExercise.id}
                    exercise={assignedExercise}
                    expanded={expandedId === assignedExercise.id}
                    toggleExpand={() => toggleExpand(assignedExercise.id)}
                />
            ))}
        </div>
    );
};

export default OwnerAssignedExercisesList;